import Subscription2WorkflowDetail from '@/features/Workflow/WorkflowDetail/subscription2/SubscriptionWorkflowDetail';

const CreateSubscription2WorkflowPage = () => {
  return <Subscription2WorkflowDetail mode="CREATE" />;
};

export default CreateSubscription2WorkflowPage;
